// extracted by mini-css-extract-plugin
module.exports = {"bm-card":"bm-card","bm-card-image":"bm-card-image","bm-card-content":"bm-card-content","bm-card-footer":"bm-card-footer"};